import React, { useEffect, useRef } from 'react';

function Test() {
  const divRef = useRef(null);

  useEffect(() => {
    const handleScroll = () => {
      console.log('L\'utilisateur a scrollé !');
    };

    const divElement = divRef.current;
    if (divElement) {
      divElement.addEventListener('scroll', handleScroll);
    }

    // Nettoyage de l'événement lors du démontage du composant
    return () => {
      if (divElement) {
        divElement.removeEventListener('scroll', handleScroll);
      }
    };
  }, []);

  return (
    <div 
      ref={divRef} 
      style={{ height: "500px", width: "100%", overflowY: 'scroll', backgroundColor: 'green' }}>
      <div style={{ height: "10000px" }}>Test</div>
    </div>
  );
}

export default Test;
